import { Component, OnDestroy, OnInit } from '@angular/core';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
// tslint:disable-next-line:import-blacklist
import { Subscription } from 'rxjs';
import { DataProcessingService } from '../data-processing/data-processing.service';

@Component({
  selector: 'app-change-modifier',
  templateUrl: './change-modifier.component.html',
  styleUrls: ['./change-modifier.component.scss'],
})
export class ChangeModifierComponent implements OnInit, OnDestroy {
  private suscriptions: Subscription[] = [];
  protected modifierList = [];
  protected PUModifier: null;
  protected DOModifier: null;
  protected isPuModifier = false;
  protected isDoModifier = false;
  protected tripList = [];

  constructor(
    private _reservationService: ReservationService,
    private _sweetAlertHelper: SweetAlertHelper,
    private _t2LoadingService: T2LoadingService,
    private _dataProcessingService: DataProcessingService
  ) {}

  ngOnInit() {
    this.observables();
  }

  observables() {
    this.suscriptions.push(
      this._reservationService.getTripModifiers().subscribe({
        next: (data: any) => {
          if (data) {
            this.modifierList = data;
          }
        },
        error: (err) => {
          this._sweetAlertHelper.captureException(err);
        },
      }),
      this._dataProcessingService.closeModal$.subscribe({
        next: () => {
          this.setModifier();
        },
      }),
      this._dataProcessingService.tripIdList$.subscribe({
        next: (value: number[]) => {
          if (value) {
            this.tripList = value;
          }
        },
      })
    );
  }

  disabledModifier() {
    if (!this.isPuModifier) {
      this.PUModifier = null;
    }
    if (!this.isDoModifier) {
      this.DOModifier = null;
    }
  }

  saveModifier() {
    this._sweetAlertHelper
      .createCustomAlert({
        title: 'Are you sure ?',
        text: 'You will not be able to revert this!',
        type: 'warning',
        showCancelButton: true,
      })
      .then((result) => {
        if (result && result.value && (this.PUModifier || this.DOModifier)) {
          this._t2LoadingService.show();
          const data = {
            PUModifier: this.PUModifier ? this.PUModifier : null,
            DOModifier: this.DOModifier ? this.DOModifier : null,
            TripIds: this.tripList,
          };
          if (data && this.tripList && this.tripList.length) {
            this.suscriptions.push(
              this._dataProcessingService
                .setModifier(data)
                .finally(() => {
                  this._t2LoadingService.hiden();
                })
                .subscribe({
                  next: (response: any) => {
                    if (response.data && response.data.length) {
                      this._sweetAlertHelper.captureExceptionList(
                        response,
                        'Trip Modifier Changed',
                        'info'
                      );
                    }
                  },
                  error: (err) => {
                    this._sweetAlertHelper.captureException(err);
                  },
                })
            );
          }
        } else {
          this._dataProcessingService.closeModal.next(true);
        }
      });
  }

  closeModalChangeModifier() {
    this._dataProcessingService.closeModal.next(true);
  }

  setModifier() {
    this.isPuModifier = false;
    this.isDoModifier = false;
    this.PUModifier = null;
    this.DOModifier = null;
  }

  get disabledSaveModifier(): boolean {
    return !this.PUModifier && !this.DOModifier;
  }

  ngOnDestroy(): void {
    this.suscriptions.forEach((sub) => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/change-modifier/change-modifier.component.ts